import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "api/esg/graphs";

export function get(id, params) {
  const query = getQuery(params);
  return axiosClient.get(`${baseUrl}/${id}`, query);
}
